import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const Question = () => {
  return (
    <Button
      href="https://zoomdream.cn"
      icon={<QuestionCircleOutlined />}
      rel="noopener noreferrer"
      size="small"
      target="_blank"
      type="text"
    />
  );
};
